/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preparing_Translation_JobsInputs */



/**
* | output |
* | --- |
* | "Preparing translation jobs..." |
*
* @param {Preparing_Translation_JobsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preparing_translation_jobs = /** @type {((inputs?: Preparing_Translation_JobsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preparing_Translation_JobsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Préparation des tâches de traduction...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzungsaufträge werden vorbereitet...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Preparazione dei lavori di traduzione...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подготовка заказов на перевод...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Preparando trabajos de traducción...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("准备翻译工作……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳ジョブを準備しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद संबंधी कार्य तैयार किए जा रहे हैं...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Preparando trabalhos de tradução...")
	return /** @type {LocalizedString} */ ("Preparing translation jobs...")
});